var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvalidTax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 413.385,
    height: 308.061,
    viewBox: "0 0 413.385 308.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f,.s{fill:#ebebeb;}.b{fill:#e6e6e6;}.c{fill:#f0f0f0;}.d{fill:#fafafa;}.e{fill:#fff;}.f{opacity:0.6;}.g{fill:#f5f5f5;}.h{fill:#e0e0e0;}.i{fill:#407bff;}.j,.k,.l{fill:url(#a);}.k{opacity:0.5;}.l{opacity:0;}.m{font-size:8px;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;}.n{fill:#263238;}.o{fill:#455a64;}.p{fill:#ffbe9d;}.q{fill:#a36957;}.r,.s{stroke:rgba(0,0,0,0);stroke-linecap:round;stroke-linejoin:round;}.r,.u{fill:url(#d);}.t{opacity:0.3;}.v{filter:url(#o);}.w{filter:url(#l);}.x{filter:url(#h);}.y{filter:url(#f);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.008,
    y1: 0.075,
    x2: 0.992,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4083f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#609bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b79e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#548ded"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.982,
    y1: 0.015,
    x2: 0.015,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7eaeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#4583ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#427bdd",
    stopOpacity: 0.922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#759fe6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 285.209,
    y: 70.217,
    width: 91.465,
    height: 87.135,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 326.618,
    y: 86.316,
    width: 50.546,
    height: 45.799,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 250.31,
    y: 12.389,
    width: 44.844,
    height: 50.756,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "m"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "m"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 255.79,
    y: 34.322,
    width: 33.311,
    height: 33.314,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.153
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-435.999 -245.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(433 190.547)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 54.953)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 413.385,
    height: 0.207,
    transform: "translate(0 270.722)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 27.384,
    height: 0.207,
    transform: "translate(344.58 284.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.187,
    height: 0.207,
    transform: "translate(266.655 286.273)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.868,
    height: 0.207,
    transform: "translate(327.885 276.352)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35.711,
    height: 0.207,
    transform: "translate(43.372 277.741)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.236,
    height: 0.207,
    transform: "translate(86.443 277.741)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 77.448,
    height: 0.207,
    transform: "translate(108.696 281.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M202.575,288.8H42.926a4.725,4.725,0,0,1-4.719-4.719V59.671a4.724,4.724,0,0,1,4.719-4.718H202.575a4.724,4.724,0,0,1,4.718,4.718V284.083A4.725,4.725,0,0,1,202.575,288.8ZM42.926,55.16a4.517,4.517,0,0,0-4.513,4.512V284.083a4.517,4.517,0,0,0,4.513,4.512H202.575a4.517,4.517,0,0,0,4.512-4.512V59.671a4.517,4.517,0,0,0-4.512-4.512Z",
    transform: "translate(-6.619 -54.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M418.871,288.8H259.223a4.724,4.724,0,0,1-4.718-4.719V59.671a4.724,4.724,0,0,1,4.718-4.718H418.871a4.724,4.724,0,0,1,4.72,4.718V284.083A4.725,4.725,0,0,1,418.871,288.8ZM259.223,55.16a4.517,4.517,0,0,0-4.512,4.512V284.083a4.517,4.517,0,0,0,4.512,4.512H418.871a4.518,4.518,0,0,0,4.513-4.512V59.671a4.518,4.518,0,0,0-4.513-4.512Z",
    transform: "translate(-44.088 -54.953)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.241 23.876)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 113.913,
    height: 74.597,
    transform: "translate(123.179 74.597) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 115.765,
    height: 74.597,
    transform: "translate(121.555 74.597) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 113.913,
    height: 14.64,
    transform: "translate(123.179 89.237) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 115.765,
    height: 14.64,
    transform: "translate(115.765 89.237) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 64.865,
    height: 106.033,
    transform: "translate(116.689 4.866) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M383.437,154.583,369.894,89.718H348.761L362.3,154.583Z",
    transform: "translate(-290.657 -84.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M416.824,150.329a.347.347,0,0,0,.347-.347V93.473a.348.348,0,0,0-.7,0v56.509A.348.348,0,0,0,416.824,150.329Z",
    transform: "translate(-302.388 -85.442)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M355.086,154.583,341.543,89.718H333.3l13.543,64.865Z",
    transform: "translate(-287.98 -84.851)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 64.865,
    height: 0.618,
    transform: "translate(11.274 4.866) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M284.095,97.45H398.008l.448-5.445H284.543Z",
    transform: "translate(-279.455 -85.248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M284.095,108.252H398.008l.448-5.445H284.543Z",
    transform: "translate(-279.455 -87.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M284.095,119.054H398.008l.448-5.445H284.543Z",
    transform: "translate(-279.455 -88.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M284.095,129.856H398.008l.448-5.445H284.543Z",
    transform: "translate(-279.455 -90.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M284.095,140.658H398.008l.448-5.445H284.543Z",
    transform: "translate(-279.455 -92.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M284.095,151.46H398.008l.448-5.445H284.543Z",
    transform: "translate(-279.455 -94.604)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252.856 162.361)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 23.884,
    height: 4.709,
    transform: "translate(60.324 54.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.409,
    height: 108.361,
    transform: "translate(19.681 108.361) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 60.324,
    height: 4.709,
    transform: "translate(60.324 58.819) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 23.884,
    height: 4.709,
    transform: "translate(60.324 79.878)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 60.324,
    height: 4.709,
    transform: "translate(60.324 84.587) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 23.884,
    height: 4.709,
    transform: "translate(60.324 2.575)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 60.324,
    height: 4.709,
    transform: "translate(60.324 7.284) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 23.884,
    height: 4.709,
    transform: "translate(60.324 28.343)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 60.324,
    height: 4.709,
    transform: "translate(60.324 33.052) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.409,
    height: 108.361,
    transform: "translate(80.005 108.361) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 4.409,
    height: 108.361,
    transform: "translate(60.324 108.361) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 4.409,
    height: 108.361,
    transform: "translate(4.409 108.361) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.049 183.174)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 45.123,
    height: 87.549,
    transform: "translate(45.123 87.549) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M77.423,379.867H65.374V367.781H90.057Z",
    transform: "translate(-65.374 -292.318)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 45.123,
    height: 87.549,
    transform: "translate(168.155 87.549) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 133.547,
    height: 83.389,
    transform: "translate(133.547 83.389) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M209.682,379.867h12.049V367.781H197.048Z",
    transform: "translate(-88.184 -292.318)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 114.853,
    height: 20.868,
    transform: "translate(124.2 51.942) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 114.853,
    height: 20.868,
    transform: "translate(124.2 77.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4.039,0H74.72a4.039,4.039,0,0,1,4.039,4.039v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A4.039,4.039,0,0,1,4.039,0Z",
    transform: "translate(106.153 33.305) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 114.853,
    height: 20.868,
    transform: "translate(124.2 26.613) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4.039,0H74.721a4.039,4.039,0,0,1,4.039,4.039v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A4.039,4.039,0,0,1,4.039,0Z",
    transform: "translate(106.153 7.976) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4.039,0H74.721a4.039,4.039,0,0,1,4.039,4.039v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A4.039,4.039,0,0,1,4.039,0Z",
    transform: "translate(106.153 58.633) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.971 23.876)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 113.913,
    height: 74.597,
    transform: "translate(123.179 74.597) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 115.765,
    height: 74.597,
    transform: "translate(121.555 74.597) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 113.913,
    height: 14.64,
    transform: "translate(123.179 89.237) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 115.765,
    height: 14.64,
    transform: "translate(115.765 89.237) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 64.865,
    height: 106.033,
    transform: "translate(116.689 4.866) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M167.814,154.583,154.271,89.718H133.138l13.543,64.865Z",
    transform: "translate(-75.035 -84.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M201.2,150.329a.347.347,0,0,0,.348-.347V93.473a.348.348,0,0,0-.7,0v56.509A.347.347,0,0,0,201.2,150.329Z",
    transform: "translate(-86.765 -85.442)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M139.464,154.583,125.921,89.718h-8.239l13.543,64.865Z",
    transform: "translate(-72.357 -84.851)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 64.865,
    height: 0.618,
    transform: "translate(11.274 4.866) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M68.472,97.45H182.385l.448-5.445H68.92Z",
    transform: "translate(-63.833 -85.248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M68.472,101.166H182.385l.448-5.445H68.92Z",
    transform: "translate(-63.833 -85.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M68.472,104.881H182.385l.448-5.445H68.92Z",
    transform: "translate(-63.833 -86.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M68.472,108.6H182.385l.448-5.445H68.92Z",
    transform: "translate(-63.833 -87.178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M68.472,112.312H182.385l.448-5.445H68.92Z",
    transform: "translate(-63.833 -87.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M68.472,116.027H182.385l.448-5.445H68.92Z",
    transform: "translate(-63.833 -88.466)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.722 122.401)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 3.938,
    height: 43.895,
    transform: "translate(19.597 58.098) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 1.112,
    height: 43.895,
    transform: "translate(17.278 58.068) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 0.436,
    height: 43.895,
    transform: "translate(18.18 58.068) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H29.155a0,0,0,0,1,0,0V0a3.673,3.673,0,0,1-3.673,3.673H3.673A3.673,3.673,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(32.205 60.773) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M89.6,246.633h0A1.135,1.135,0,0,0,90.73,245.5v-28.78a1.136,1.136,0,0,0-1.133-1.133h0a1.137,1.137,0,0,0-1.133,1.133V245.5A1.136,1.136,0,0,0,89.6,246.633Z",
    transform: "translate(-79.047 -205.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M77.074,227.637h35.256L108.274,203H81.129Z",
    transform: "translate(-77.074 -203)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.391 344.291)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 160.302,
    cy: 9.362,
    rx: 160.302,
    ry: 9.362
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.256 134.707)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 0.827,
    height: 15.286,
    transform: "matrix(0.997, -0.072, 0.072, 0.997, 0, 42.176)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 0.827,
    height: 5.751,
    transform: "translate(1.665 65.296) rotate(-4.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M297.15,286.8H120.091a7.976,7.976,0,0,1-7.806-7.281l-8.7-120.815a6.7,6.7,0,0,1,6.756-7.281H287.4a7.976,7.976,0,0,1,7.806,7.281l8.7,120.815A6.7,6.7,0,0,1,297.15,286.8Z",
    transform: "translate(-103.197 -151.418)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.049)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M297.971,286.8H120.912a7.976,7.976,0,0,1-7.806-7.281l-8.7-120.815a6.7,6.7,0,0,1,6.756-7.281H288.223a7.976,7.976,0,0,1,7.806,7.281l8.7,120.815A6.7,6.7,0,0,1,297.971,286.8Z",
    transform: "translate(-104.388 -151.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M297.971,286.8H120.912a7.976,7.976,0,0,1-7.806-7.281l-8.7-120.815a6.7,6.7,0,0,1,6.756-7.281H288.223a7.976,7.976,0,0,1,7.806,7.281l8.7,120.815A6.7,6.7,0,0,1,297.971,286.8Z",
    transform: "translate(-104.388 -151.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M289.214,155.821H112.155q-.3,0-.593.024c-4.527.373-3.6,7.257.966,7.257H289.89c4.568,0,4.5-6.885-.079-7.257Q289.515,155.821,289.214,155.821Z",
    transform: "translate(-105.117 -152.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M117.778,159.874a1.533,1.533,0,0,1-1.549,1.67,1.823,1.823,0,0,1-1.789-1.67,1.532,1.532,0,0,1,1.549-1.668A1.822,1.822,0,0,1,117.778,159.874Z",
    transform: "translate(-106.128 -152.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M124.646,159.874a1.533,1.533,0,0,1-1.549,1.67,1.823,1.823,0,0,1-1.789-1.67,1.531,1.531,0,0,1,1.549-1.668A1.822,1.822,0,0,1,124.646,159.874Z",
    transform: "translate(-107.318 -152.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M131.514,159.874a1.533,1.533,0,0,1-1.549,1.67,1.823,1.823,0,0,1-1.789-1.67,1.531,1.531,0,0,1,1.549-1.668A1.823,1.823,0,0,1,131.514,159.874Z",
    transform: "translate(-108.508 -152.594)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M295.265,278.653H125.858a2.883,2.883,0,0,1-2.829-2.64l-7.155-99.355a2.424,2.424,0,0,1,2.45-2.64H287.731a2.884,2.884,0,0,1,2.83,2.64l7.154,99.355A2.423,2.423,0,0,1,295.265,278.653Z",
    transform: "translate(-105.328 -155.333)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.964 41.746)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.101)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M239.385,245.72l-2.758-38.3-8.356-5.03H205.283l3.12,43.325Z",
    transform: "translate(-204.883 -201.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M239.3,246.037H208.319a.4.4,0,0,1-.4-.372L204.8,202.34a.4.4,0,0,1,.4-.429h22.987a.4.4,0,0,1,.207.057l8.356,5.03a.4.4,0,0,1,.193.314l2.757,38.3a.4.4,0,0,1-.4.43Zm-30.609-.8H238.87l-2.712-37.659-8.083-4.866H205.63Z",
    transform: "translate(-204.799 -201.911)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.987 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.444,207.425l-8.356-5.03,3.068,6.663Z",
    transform: "translate(-232.687 -201.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M236.071,209.375a.4.4,0,0,1-.364-.233l-3.068-6.663a.4.4,0,0,1,.57-.511l8.356,5.03a.4.4,0,0,1-.088.726l-5.288,1.634A.413.413,0,0,1,236.071,209.375Zm-2.16-6.049,2.378,5.163,4.1-1.266Z",
    transform: "translate(-232.603 -201.911)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.833 18.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M220.235,225.638a1.606,1.606,0,0,1-1.624,1.75,1.911,1.911,0,0,1-1.877-1.75,1.606,1.606,0,0,1,1.625-1.749A1.91,1.91,0,0,1,220.235,225.638Z",
    transform: "translate(-214.699 -223.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M233.971,225.638a1.607,1.607,0,0,1-1.625,1.75,1.911,1.911,0,0,1-1.876-1.75,1.606,1.606,0,0,1,1.624-1.749A1.911,1.911,0,0,1,233.971,225.638Z",
    transform: "translate(-217.078 -223.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M234.369,238.42a.4.4,0,0,1-.4-.372c-.2-2.814-4.617-5.1-9.839-5.1-3.46,0-6.567,1.028-8.107,2.685a3.089,3.089,0,0,0-.943,2.361.4.4,0,0,1-.8.057,3.911,3.911,0,0,1,1.155-2.964c1.687-1.814,5.019-2.941,8.694-2.941,5.729,0,10.4,2.569,10.638,5.848a.4.4,0,0,1-.371.428Z",
    transform: "translate(-214.273 -225.319)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M213.083,221.153a.4.4,0,0,1-.294-.674l1.755-1.892a.4.4,0,0,1,.588.545l-1.755,1.892A.4.4,0,0,1,213.083,221.153Z",
    transform: "translate(-206.164 -204.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M237.075,221.153a.4.4,0,0,1-.273-.108l-2.028-1.892a.4.4,0,1,1,.547-.585l2.028,1.892a.4.4,0,0,1-.274.694Z",
    transform: "translate(-209.969 -204.778)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(-8.219 54.999)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Invalid Tax ID"))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(692.369 261.518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.25 26.722)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M566.715,104.97c-2.225.512-3.308,3.072-3.519,5.346s.079,4.674-.876,6.748c-1.074,2.334-3.641,4.055-3.727,6.623-.052,1.566.878,3.039.833,4.6-.073,2.573-2.7,4.516-2.834,7.085-.1,1.85,1.133,3.626.837,5.455-.231,1.423-1.339,2.545-1.807,3.908-.935,2.719.933,5.711,3.366,7.242a11.034,11.034,0,0,0,16.077-5.137c1.346-3.268,1.052-6.948.76-10.469q-1.368-16.465-2.032-32.977",
    transform: "translate(-555.378 -103.399)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.875 2.44)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M561.823,144.488a2.668,2.668,0,0,0,1.017-1.209,4.291,4.291,0,0,0,.259-1.847,10.233,10.233,0,0,0-.552-2.45,6.992,6.992,0,0,1-.4-3.1,7.076,7.076,0,0,1,1.8-3.1,6.9,6.9,0,0,0,1.021-1.553,2.508,2.508,0,0,0,.119-1.814c-.391-1.236-1.6-2.146-2.158-3.572a3.856,3.856,0,0,1-.122-2.208,8.967,8.967,0,0,1,.73-1.981,16.947,16.947,0,0,0,1.5-3.56c.531-2.4.283-4.691.645-6.573a7.3,7.3,0,0,1,1.913-4.032,4.31,4.31,0,0,1,1-.713,1.726,1.726,0,0,1,.4-.15,6.112,6.112,0,0,0-1.292.971,7.362,7.362,0,0,0-1.747,3.97,24.769,24.769,0,0,0-.21,3.058,18.7,18.7,0,0,1-.356,3.552,16.89,16.89,0,0,1-1.508,3.643,4.977,4.977,0,0,0-.588,3.886c.481,1.288,1.7,2.2,2.157,3.594a2.889,2.889,0,0,1-.141,2.08,7.228,7.228,0,0,1-1.085,1.632,4.963,4.963,0,0,0-1.423,5.894,10.093,10.093,0,0,1,.5,2.517,4.318,4.318,0,0,1-.338,1.918,2.3,2.3,0,0,1-.776.955A1.249,1.249,0,0,1,561.823,144.488Z",
    transform: "translate(-561.821 -106.624)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M541.068,180.366l-6.83,19.69-28.484,1.527L501,212.152l29.737,3.009a11.236,11.236,0,0,0,14.869-6.594l7.936-22.152Z",
    transform: "translate(-492.898 -95.405)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.155 140.143)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M614.793,383.747s-20.874-66.3-21.317-68.45c-.4-1.945,7.576-49.655,8.58-62l-28.2,1.052,0,.206-11.989.664L572.6,390.806h12.979l-1.286-44.985A438.1,438.1,0,0,0,603.762,389.2Z",
    transform: "translate(-561.86 -253.293)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.941 80.017)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M590.589,387.675c.011-.412-.157-15.072-.157-15.072-.162.877-4.976-12.73-4.859-13.557C585.632,358.618,590.589,387.675,590.589,387.675Z",
    transform: "translate(-585.57 -359.042)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.289 73.581)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M584.813,350.535a3.032,3.032,0,0,0-.083.822,21.687,21.687,0,0,0,.017,2.247c.018.476.067.994.129,1.55s.147,1.15.275,1.766a30.129,30.129,0,0,0,1.061,3.95c.942,2.743,1.982,5.142,2.72,6.883q.526,1.191.9,2.05a3.036,3.036,0,0,0,.385.73,3.1,3.1,0,0,0-.229-.793c-.174-.5-.439-1.218-.776-2.1-.667-1.77-1.661-4.187-2.6-6.905a34.283,34.283,0,0,1-1.08-3.892c-.137-.6-.225-1.189-.31-1.734s-.142-1.057-.18-1.526c-.089-.937-.129-1.7-.153-2.227A3.077,3.077,0,0,0,584.813,350.535Z",
    transform: "translate(-584.709 -350.535)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.714 276.527)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M572.856,435.332l-.005-1.219,13.295-.579.036,5.028-.82.055c-3.649.213-18.57.829-21.012.1C561.625,437.9,572.856,435.332,572.856,435.332Z",
    transform: "translate(-563.923 -433.534)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.716)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M586.366,439.774a1.149,1.149,0,0,1-.227.026l-.653.042-2.4.113c-2.03.08-4.837.154-7.937.168s-5.908-.036-7.939-.1l-2.4-.091-.653-.036a1.164,1.164,0,0,1-.228-.023,1.247,1.247,0,0,1,.229-.008l.655.006,2.4.04c2.031.033,4.837.064,7.936.051s5.9-.07,7.935-.121l2.4-.061.654-.012A1.263,1.263,0,0,1,586.366,439.774Z",
    transform: "translate(-563.921 -439.767)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.35 3.085)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M569.625,439.678a3.494,3.494,0,0,0-1.276-2.063,2.135,2.135,0,0,1,1.276,2.063Z",
    transform: "translate(-568.349 -437.611)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.814 2.058)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M574.957,437.353c-.038.023-.225-.2-.419-.506s-.321-.568-.284-.592.225.2.418.505S574.994,437.33,574.957,437.353Z",
    transform: "translate(-574.247 -436.254)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.76 1.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M576.33,436.714c-.03.033-.238-.105-.467-.309s-.39-.4-.361-.429.239.105.468.309S576.359,436.682,576.33,436.714Z",
    transform: "translate(-575.498 -435.971)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.883 1.266)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M577.042,435.277a1.543,1.543,0,0,1-.69.091,1.572,1.572,0,0,1-.692-.07,1.555,1.555,0,0,1,.689-.091A1.575,1.575,0,0,1,577.042,435.277Z",
    transform: "translate(-575.66 -435.207)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.929 0.443)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M577.286,434.132a1.948,1.948,0,0,1-1.565.123,4.326,4.326,0,0,1,.783-.057A4.275,4.275,0,0,1,577.286,434.132Z",
    transform: "translate(-575.721 -434.119)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.575 0.822)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M573.784,435.8a2.439,2.439,0,0,1-.85,0,4.985,4.985,0,0,1-.906-.2,2.488,2.488,0,0,1-.519-.212.457.457,0,0,1-.211-.263.334.334,0,0,1,.128-.341,1.558,1.558,0,0,1,1.929.449,1.512,1.512,0,0,1,.279.566.481.481,0,0,1,.023.23,2.413,2.413,0,0,0-.39-.724,1.531,1.531,0,0,0-.727-.469,1.322,1.322,0,0,0-1.013.073c-.135.1-.081.26.069.348a2.58,2.58,0,0,0,.479.2,5.878,5.878,0,0,0,.876.224C573.46,435.778,573.784,435.778,573.784,435.8Z",
    transform: "translate(-571.288 -434.621)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.743 0.4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M574.261,435.711a.84.84,0,0,1-.1-.589,1.385,1.385,0,0,1,.23-.622.851.851,0,0,1,.706-.436.338.338,0,0,1,.263.391.94.94,0,0,1-.143.381,2.558,2.558,0,0,1-.4.515,1.222,1.222,0,0,1-.485.346c-.015-.02.169-.153.4-.423a2.975,2.975,0,0,0,.354-.511c.116-.18.195-.5-.019-.541-.213-.02-.429.193-.558.362a1.415,1.415,0,0,0-.238.554A3.183,3.183,0,0,0,574.261,435.711Z",
    transform: "translate(-574.154 -434.063)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.474 1.019)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M591.7,434.967c0,.03-.379-.035-.976.038a4.142,4.142,0,0,0-3.455,2.774c-.2.568-.218.949-.247.945a.755.755,0,0,1,0-.266,3.465,3.465,0,0,1,.141-.714,4.018,4.018,0,0,1,3.551-2.851,3.475,3.475,0,0,1,.727.016A.747.747,0,0,1,591.7,434.967Z",
    transform: "translate(-587.014 -434.881)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.93 3.653)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M583.553,438.379a10.866,10.866,0,0,1-3.866.021c0-.047.868.01,1.933,0S583.548,438.333,583.553,438.379Z",
    transform: "translate(-579.687 -438.362)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.011 3.637)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M588.1,438.345c.032.032-.07.183-.158.381s-.135.375-.18.372-.069-.209.034-.437S588.071,438.314,588.1,438.345Z",
    transform: "translate(-587.724 -438.34)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.859 2.416)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M589.345,436.733c.032.031-.053.17-.19.308s-.272.227-.3.2.054-.169.19-.308S589.313,436.7,589.345,436.733Z",
    transform: "translate(-588.845 -436.727)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.001 1.787)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M591.109,435.97c-.009.045-.185.044-.379.114s-.334.173-.369.143.075-.213.316-.3S591.121,435.929,591.109,435.97Z",
    transform: "translate(-590.354 -435.895)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.351 1.566)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M592.537,435.633c.016.042-.06.11-.169.152s-.211.045-.228,0,.06-.11.169-.153S592.52,435.593,592.537,435.633Z",
    transform: "translate(-592.137 -435.604)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.884 270.068)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M614.67,432.082l-.5-1.109L626.057,425l2.093,4.572-.726.387c-3.242,1.69-16.6,8.363-19.129,8.7C605.476,439.022,614.67,432.082,614.67,432.082Z",
    transform: "translate(-607.758 -424.998)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 4.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M628.195,430.573a1.327,1.327,0,0,1-.2.117l-.578.306-2.147,1.087c-1.819.9-4.349,2.122-7.172,3.405s-5.4,2.387-7.283,3.161l-2.231.9-.611.235a1.2,1.2,0,0,1-.217.072,1.16,1.16,0,0,1,.2-.1l.6-.263,2.211-.949c1.866-.8,4.439-1.922,7.26-3.2s5.357-2.481,7.188-3.36l2.169-1.041.592-.278A1.275,1.275,0,0,1,628.195,430.573Z",
    transform: "translate(-607.759 -430.572)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.347 10.53)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M612.87,440.292a3.5,3.5,0,0,0-2.01-1.36,2.137,2.137,0,0,1,2.01,1.36Z",
    transform: "translate(-610.86 -438.914)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.001 7.772)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M616.782,435.99c-.024.037-.288-.093-.589-.29s-.526-.387-.5-.424.288.093.589.291S616.806,435.953,616.782,435.99Z",
    transform: "translate(-615.689 -435.27)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.777 7.184)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M617.773,434.843c-.014.042-.261,0-.553-.091s-.518-.2-.5-.244.261,0,.553.091S617.786,434.8,617.773,434.843Z",
    transform: "translate(-616.714 -434.492)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.684 6.11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M617.844,433.081c.018.04-.247.2-.593.365a1.557,1.557,0,0,1-.66.22c-.019-.04.246-.2.592-.365A1.561,1.561,0,0,1,617.844,433.081Z",
    transform: "translate(-616.591 -433.072)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.407 5.217)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M617.6,431.9c.029.03-.214.307-.609.522a1.347,1.347,0,0,1-.768.232,4.174,4.174,0,0,1,.691-.373A4.319,4.319,0,0,1,617.6,431.9Z",
    transform: "translate(-616.226 -431.892)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.6 7.103)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M615.124,434.91a2.451,2.451,0,0,1-.776.346,4.948,4.948,0,0,1-.906.192,2.452,2.452,0,0,1-.56.02.461.461,0,0,1-.3-.154.333.333,0,0,1-.023-.362,1.558,1.558,0,0,1,1.943-.381,1.517,1.517,0,0,1,.487.4c.091.118.123.2.114.2a2.4,2.4,0,0,0-.651-.5,1.529,1.529,0,0,0-.857-.13,1.318,1.318,0,0,0-.894.481c-.082.147.032.269.205.289a2.546,2.546,0,0,0,.52-.011,5.783,5.783,0,0,0,.891-.154C614.818,435.018,615.114,434.885,615.124,434.91Z",
    transform: "translate(-612.515 -434.386)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.627 5.905)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M615.593,434.654a.838.838,0,0,1-.333-.5,1.4,1.4,0,0,1-.045-.661.855.855,0,0,1,.466-.687c.19-.058.633.324.664.467.048.142-.224.069-.238.188a2.608,2.608,0,0,1-.154.634,1.213,1.213,0,0,1-.3.514c-.022-.013.091-.209.194-.55a2.96,2.96,0,0,0,.113-.612c.033-.211-.028-.538-.238-.486-.2.07-.313.352-.361.56a1.4,1.4,0,0,0,.009.6A3.138,3.138,0,0,0,615.593,434.654Z",
    transform: "translate(-615.195 -432.802)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.659 1.031)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M631.49,426.363c.009.029-.36.124-.875.435a4.142,4.142,0,0,0-2.015,3.945c.05.6.19.955.161.964a.774.774,0,0,1-.11-.243,3.468,3.468,0,0,1-.163-.709,4.021,4.021,0,0,1,2.071-4.056,3.494,3.494,0,0,1,.67-.284A.787.787,0,0,1,631.49,426.363Z",
    transform: "translate(-628.453 -426.361)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.42 5.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M625.047,432.9a10.849,10.849,0,0,1-3.518,1.6c-.015-.044.8-.346,1.765-.789S625.023,432.861,625.047,432.9Z",
    transform: "translate(-621.529 -432.899)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.143 4.893)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M629.24,431.466c.042.016.011.2.013.412s.03.4-.013.413-.148-.162-.148-.412S629.2,431.448,629.24,431.466Z",
    transform: "translate(-629.092 -431.464)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.413 3.382)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M629.714,429.469c.042.015.021.176-.046.359s-.156.319-.2.3-.02-.176.047-.359S629.673,429.453,629.714,429.469Z",
    transform: "translate(-629.449 -429.467)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.128 2.279)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M630.988,428.031c.01.045-.151.116-.3.258s-.233.294-.277.281-.019-.225.168-.4S630.983,427.988,630.988,428.031Z",
    transform: "translate(-630.393 -428.009)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.212 1.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M632.135,427.176c.032.031-.01.124-.092.208s-.175.127-.206.1.009-.125.092-.209S632.1,427.145,632.135,427.176Z",
    transform: "translate(-631.826 -427.166)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.193 64.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.146)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "y",
    transform: "matrix(1, 0, 0, 1, -300.71, -80.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M596.106,206.591l-2.214-27.011,11.372.2s.527-3.982-1.149-12.719c-1.028-5.357-4.6-8.642-8.6-10.594V156.4l-.347-.091a32.5,32.5,0,0,0-10.416-2.718l-13.958.161s-10.663-1.33-16.565,6.271c-2.274,2.928-9.309,22.969-9.309,22.969l16.754,8.069-1.594-11.113s.316,8.057,1.345,10.61c.573,1.423,2.231,5.839,2.231,5.839l-.216,13.328Z",
    transform: "translate(-244.22 -72.87)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.409 16.098)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "x",
    transform: "matrix(1, 0, 0, 1, -342.12, -96.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M601.721,180.836l-2.072,8.827h19.546l-1.286-14.8Z",
    transform: "translate(-257.53 -78.05)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.251 30.478)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M619.787,194.287a14.553,14.553,0,0,0-2.587-.257c-1.6-.094-3.818-.173-6.268-.162s-4.667.118-6.268.245a13.965,13.965,0,0,0-2.581.319,17.453,17.453,0,0,0,2.6-.014c1.6-.049,3.811-.107,6.253-.119s4.654.02,6.255.036A16.6,16.6,0,0,0,619.787,194.287Z",
    transform: "translate(-602.083 -193.868)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.568 16.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M601.251,174.768a11.726,11.726,0,0,0-.065,2.246c.015,1.385.065,3.3.147,5.408s.18,4.022.273,5.4a11.632,11.632,0,0,0,.239,2.233,11.548,11.548,0,0,0,.065-2.245c-.014-1.385-.064-3.3-.147-5.409s-.18-4.022-.272-5.4A11.6,11.6,0,0,0,601.251,174.768Z",
    transform: "translate(-601.181 -174.768)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "t",
    transform: "translate(24.852 23.671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.768,184.872s4.345,32.21,16.557,31.357c0,0,5.5-.065,7.266-3.72v-1.438Z",
    transform: "translate(-577.768 -184.872)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "t",
    transform: "translate(40.447 17.924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.522,177.277l-2.338,15.79,1.513,2.771,2.492-5.418-1.054-.025Z",
    transform: "translate(-598.184 -177.277)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.973 22.397)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M568.429,203.6a3.3,3.3,0,0,1-.33-.754c-.19-.493-.442-1.216-.734-2.114a64.261,64.261,0,0,1-1.87-7.148,51.668,51.668,0,0,1-.926-7.333c-.045-.945-.059-1.71-.045-2.239a3.306,3.306,0,0,1,.057-.822c.063,0,.105,1.166.267,3.042a68.174,68.174,0,0,0,1.034,7.275c.561,2.816,1.236,5.33,1.749,7.143q.36,1.261.613,2.147A3.335,3.335,0,0,1,568.429,203.6Z",
    transform: "translate(-564.518 -183.188)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.813 48.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M575.888,221.358c-.1.032-.406-.664-.675-1.552a3.743,3.743,0,0,1-.3-1.666c.1-.032.406.663.675,1.552A3.754,3.754,0,0,1,575.888,221.358Z",
    transform: "translate(-574.879 -218.139)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.062 47.217)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M578.3,220.712a6.977,6.977,0,0,1-.07-4.722,15.874,15.874,0,0,1,.017,2.362A15.9,15.9,0,0,1,578.3,220.712Z",
    transform: "translate(-577.851 -215.99)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.221)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M561.972,200.825c-.049.1-3.948-1.752-8.708-4.131s-8.581-4.387-8.533-4.484,3.947,1.752,8.709,4.131S562.02,200.728,561.972,200.825Z",
    transform: "translate(-544.73 -192.206)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.472 25.464)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.023)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M574.72,145.36c.087-3.828.108-7.86.108-7.86s-4.91-.946-5.765-7.406c-.816-6.161,1.466-20.617,1.466-20.617h0c7.173-2.711,14.625-.253,19.54,5.558h0l-1.22,31.08a6.672,6.672,0,0,1-7.219,6.179h0A7.048,7.048,0,0,1,574.72,145.36Z",
    transform: "translate(-568.887 -108.375)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.95 10.744)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.318 1.186)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M570.565,124.867a.826.826,0,0,0,.774.853.789.789,0,0,0,.869-.722.826.826,0,0,0-.773-.854A.79.79,0,0,0,570.565,124.867Z",
    transform: "translate(-570.563 -124.141)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M570.155,123.4c.1.11.736-.336,1.625-.311s1.527.487,1.626.38c.048-.047-.051-.244-.329-.458a2.268,2.268,0,0,0-1.3-.437,2.18,2.18,0,0,0-1.3.382C570.2,123.16,570.106,123.352,570.155,123.4Z",
    transform: "translate(-570.143 -122.574)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.206 11.307)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.071 1.184)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M582.471,125.608a.825.825,0,0,0,.774.853.788.788,0,0,0,.869-.722.826.826,0,0,0-.773-.854A.79.79,0,0,0,582.471,125.608Z",
    transform: "translate(-582.469 -124.882)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M582.387,124.143c.1.11.738-.336,1.625-.31s1.528.486,1.627.38c.048-.047-.05-.244-.33-.458a2.258,2.258,0,0,0-1.3-.437,2.169,2.169,0,0,0-1.3.382C582.436,123.9,582.339,124.094,582.387,124.143Z",
    transform: "translate(-582.375 -123.317)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.581 11.247)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M577.186,130.626a5.838,5.838,0,0,0-1.435-.3c-.226-.03-.44-.08-.474-.236a1.157,1.157,0,0,1,.169-.668q.342-.815.715-1.709a29.611,29.611,0,0,0,1.622-4.477,29.69,29.69,0,0,0-1.979,4.336q-.36.9-.687,1.721a1.312,1.312,0,0,0-.141.886.569.569,0,0,0,.364.341,1.543,1.543,0,0,0,.384.064A5.8,5.8,0,0,0,577.186,130.626Z",
    transform: "translate(-574.94 -123.238)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.942 27.05)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M576.739,146.2a16.371,16.371,0,0,0,8.676-2.076s-2.2,4.365-8.628,3.6Z",
    transform: "translate(-576.739 -144.123)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.947 13.404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M585.146,120.641c-.182.278-.857.154-1.614.018-.754-.151-1.427-.286-1.494-.611s.707-.744,1.716-.549S585.33,120.378,585.146,120.641Z",
    transform: "translate(-582.032 -119.45)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.934 12.591)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M573.419,119.077c-.069.323-.791.441-1.625.484s-1.566-.017-1.664-.334.606-.8,1.609-.847S573.49,118.763,573.419,119.077Z",
    transform: "translate(-570.121 -118.376)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.29 25.749)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M577.75,135.8a.449.449,0,0,0-.491.225.5.5,0,1,0,.3-.241",
    transform: "translate(-577.2 -135.765)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.006 25.683)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M577.867,135.865c.04-.036-.142-.253-.53-.169a.673.673,0,0,0-.486.475.761.761,0,0,0,.267.8.747.747,0,0,0,.851.005.639.639,0,0,0,.273-.631c-.078-.4-.373-.462-.381-.407-.033.051.1.188.076.424a.335.335,0,0,1-.18.278.384.384,0,0,1-.384-.017.4.4,0,0,1-.136-.366.383.383,0,0,1,.2-.28C577.652,135.864,577.839,135.92,577.867,135.865Z",
    transform: "translate(-576.825 -135.677)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.268)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M587.5,121.01c-.766,1.774-2.633,3.14-2.374,5.055.167,1.236.96,2.388.806,3.626-.194,1.554-1.808,2.632-2.037,4.181-.28,1.9,1.569,3.378,2.307,5.151,1.075,2.583-.3,5.487-.333,8.285a8.883,8.883,0,0,0,7.865,8.64c1.728.142,3.674-.379,4.569-1.863.739-1.225.592-2.78,1.034-4.14.661-2.025,2.59-3.507,3-5.6.742-3.811-3.864-6.965-3.561-10.836.129-1.653,1.15-3.1,1.584-4.7a6.883,6.883,0,0,0-1.351-6.123c-1.137-1.352-2.786-2.241-3.754-3.718-1.1-1.675-1.136-3.8-1.55-5.759a14.508,14.508,0,0,0-23.042-8.5s-1.1,4.987,4.019,5.821,7.492-.129,8.069,1.923a5.425,5.425,0,0,0,1.533,4.686C586.4,119.435,588.389,118.956,587.5,121.01Z",
    transform: "translate(-570.563 -101.736)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.588 13.948)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M601.006,160.084a2.1,2.1,0,0,1-.468-.048,6.917,6.917,0,0,1-1.3-.352,9.184,9.184,0,0,1-3.96-2.932,10.374,10.374,0,0,1-1.684-3,12.034,12.034,0,0,1-.688-3.885,15.823,15.823,0,0,1,.545-4.321,18.861,18.861,0,0,1,.724-2.189,21.81,21.81,0,0,0,.831-2.174,4.087,4.087,0,0,0-.008-2.219,12.074,12.074,0,0,0-.86-2.072,13.825,13.825,0,0,1-.881-2.051,4.431,4.431,0,0,1-.159-2.175,15.387,15.387,0,0,1,1.678-3.562,6.778,6.778,0,0,0,.685-3.223,7.617,7.617,0,0,0-1.687-4.464,13.487,13.487,0,0,0-1.286-1.252,5.23,5.23,0,0,1,1.4,1.152,7.589,7.589,0,0,1,1.849,4.551,7,7,0,0,1-.67,3.378,15.673,15.673,0,0,0-1.616,3.489,6.377,6.377,0,0,0,1.03,3.985,12.3,12.3,0,0,1,.893,2.14,4.486,4.486,0,0,1,.01,2.424,21.738,21.738,0,0,1-.847,2.217,18.619,18.619,0,0,0-.716,2.143,15.657,15.657,0,0,0-.555,4.216,10.918,10.918,0,0,0,2.228,6.715,9.335,9.335,0,0,0,3.8,2.962C600.363,159.975,601.015,160.04,601.006,160.084Z",
    transform: "translate(-592.485 -120.169)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.83 2.282)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M595.507,118.15a5.364,5.364,0,0,1-1.127.168,11.752,11.752,0,0,1-3.117-.082,5.925,5.925,0,0,1-3.932-2.387,12.806,12.806,0,0,1-1.032-2.54,4.2,4.2,0,0,0-1.724-2.127,12.275,12.275,0,0,0-5.307-1.385,9.217,9.217,0,0,1-4.411-1.373,4.372,4.372,0,0,1-1.805-2.527,2.722,2.722,0,0,1-.058-.853.87.87,0,0,1,.061-.292,5.558,5.558,0,0,0,.146,1.108,4.356,4.356,0,0,0,1.816,2.336,9.189,9.189,0,0,0,4.293,1.241,12.291,12.291,0,0,1,5.478,1.416,4.554,4.554,0,0,1,1.87,2.318,13.086,13.086,0,0,0,.978,2.483,5.715,5.715,0,0,0,3.68,2.309,13.24,13.24,0,0,0,3.055.2A7.673,7.673,0,0,1,595.507,118.15Z",
    transform: "translate(-572.981 -104.752)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.218 1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M594.075,111.672a2.3,2.3,0,0,1-.887.131,5.425,5.425,0,0,1-3.795-1.516,7.191,7.191,0,0,1-1.174-1.566c-.683-1.151-1.339-2.57-2.754-3.157a9.051,9.051,0,0,0-4.239-.373,12.958,12.958,0,0,1-3.618-.03,4.507,4.507,0,0,1-2.233-1,2.569,2.569,0,0,1-.445-.5c-.086-.127-.123-.2-.113-.205.032-.024.212.244.655.586a4.647,4.647,0,0,0,2.182.845,13.634,13.634,0,0,0,3.54-.057,9.114,9.114,0,0,1,4.43.374,4.375,4.375,0,0,1,1.806,1.5,20.007,20.007,0,0,1,1.1,1.834,7.1,7.1,0,0,0,1.09,1.517,5.209,5.209,0,0,0,1.3.961,5.612,5.612,0,0,0,2.267.633C593.755,111.682,594.07,111.638,594.075,111.672Z",
    transform: "translate(-574.816 -103.454)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.025 16.066)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M605.012,159.133c-.039-.017.2-.5.482-1.435a13.027,13.027,0,0,0,.5-4.056,12.46,12.46,0,0,0-1.613-5.778c-.553-.991-1.395-1.874-2.079-2.962a5.356,5.356,0,0,1-.763-1.827,4.13,4.13,0,0,1,.168-2.042,23.885,23.885,0,0,0,1.348-3.608,4.973,4.973,0,0,0-.981-3.28,15.092,15.092,0,0,1-.81-1.5,5.41,5.41,0,0,1-.428-1.58,14.006,14.006,0,0,1,.086-2.885,7.633,7.633,0,0,0-.359-4.021,3.646,3.646,0,0,0-.893-1.184c0-.006.035.008.092.043a1.527,1.527,0,0,1,.241.173,2.8,2.8,0,0,1,.7.9,7.5,7.5,0,0,1,.5,4.112,14.206,14.206,0,0,0-.039,2.822,7.166,7.166,0,0,0,1.227,2.939,9.986,9.986,0,0,1,.823,1.609,3.814,3.814,0,0,1,.228,1.91,22.628,22.628,0,0,1-1.354,3.674,3.753,3.753,0,0,0-.157,1.852,5,5,0,0,0,.7,1.694c.649,1.046,1.494,1.946,2.066,2.984a12.494,12.494,0,0,1,1.578,5.953,12.237,12.237,0,0,1-.636,4.109,8.943,8.943,0,0,1-.436,1.045A1.487,1.487,0,0,1,605.012,159.133Z",
    transform: "translate(-599.67 -122.968)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.766 115.489)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.122 0.194)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M564.261,323.966s-5.1-48.308-5.388-66.158,8.025-35.462,8.025-35.462l32.6-1.379s6.444,18.112,6.559,25.719c.225,14.784-3.928,29.384-3.45,41.112l1.09,36.168",
    transform: "translate(-558.865 -220.967)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.448 43.805)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M606.179,278.6a4.369,4.369,0,0,1-.532.4l-.3.21c-.1.086-.2.2-.316.3a4.856,4.856,0,0,0-.726.813c-1.053,1.289-1.821,3.593-2.551,6.466a21.735,21.735,0,0,1-1.65,4.6,8.283,8.283,0,0,1-.724,1.144c-.141.182-.269.376-.425.55l-.5.5A8.1,8.1,0,0,1,596,295.164c-1.825.8-3.885,1.18-5.767,2.123a9.11,9.11,0,0,0-4.184,4.769c-.918,2.051-1.475,4.2-2.24,6.212a11.259,11.259,0,0,1-3.4,5.161,9.343,9.343,0,0,1-5.335,1.672c-1.755.1-3.381.051-4.838.272a7.645,7.645,0,0,0-3.649,1.377,5.081,5.081,0,0,0-1.7,2.387,3.583,3.583,0,0,0-.126,1.855c.084.425.2.629.177.639a1.942,1.942,0,0,1-.254-.621,3.521,3.521,0,0,1,.057-1.919,5.185,5.185,0,0,1,1.7-2.514,7.8,7.8,0,0,1,3.746-1.48c1.485-.242,3.128-.207,4.858-.323a9.054,9.054,0,0,0,5.136-1.634,10.955,10.955,0,0,0,3.263-5.01c.752-1.986,1.305-4.142,2.242-6.237a9.477,9.477,0,0,1,4.368-4.952c1.958-.972,4.018-1.339,5.8-2.112a7.8,7.8,0,0,0,2.361-1.494l.481-.474c.151-.166.275-.353.412-.525a7.986,7.986,0,0,0,.707-1.1,21.837,21.837,0,0,0,1.669-4.515c.763-2.858,1.584-5.2,2.7-6.486a4.817,4.817,0,0,1,.768-.8c.12-.107.226-.213.334-.3l.313-.2A4.216,4.216,0,0,1,606.179,278.6Z",
    transform: "translate(-564.582 -278.602)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.335 21.45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M605.379,249.059a3.911,3.911,0,0,1,.042.647,8.032,8.032,0,0,1-.226,1.849,11.956,11.956,0,0,1-3.683,5.694,21.882,21.882,0,0,1-3.818,2.788c-1.46.867-3.072,1.693-4.723,2.625a24.7,24.7,0,0,0-4.831,3.4,18.662,18.662,0,0,0-3.66,5.144,47.471,47.471,0,0,1-3.173,5.591,13.359,13.359,0,0,1-2.07,2.288,13.049,13.049,0,0,1-2.461,1.639,30.479,30.479,0,0,1-5.065,1.942c-1.618.5-3.127.944-4.445,1.5a17.339,17.339,0,0,0-3.391,1.816,10.543,10.543,0,0,0-2.129,1.963,10.157,10.157,0,0,0-1.277,2.122,3.974,3.974,0,0,1,.21-.614,7.493,7.493,0,0,1,.946-1.6,10.35,10.35,0,0,1,2.121-2.047,17.167,17.167,0,0,1,3.411-1.895c1.33-.576,2.847-1.037,4.455-1.55a30.622,30.622,0,0,0,4.995-1.951,12.762,12.762,0,0,0,2.384-1.6,13.027,13.027,0,0,0,2-2.228,47.933,47.933,0,0,0,3.14-5.551,18.948,18.948,0,0,1,3.742-5.239,24.8,24.8,0,0,1,4.919-3.433c1.665-.929,3.279-1.742,4.736-2.59a21.971,21.971,0,0,0,3.8-2.713,12.054,12.054,0,0,0,3.722-5.527A11.689,11.689,0,0,0,605.379,249.059Z",
    transform: "translate(-560.467 -249.059)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M559,260.3a.489.489,0,0,1-.066-.147,3.246,3.246,0,0,1-.071-2.265,7.417,7.417,0,0,1,4.792-4.418c1.342-.461,2.865-.739,4.451-1.155a8.337,8.337,0,0,0,6.167-4.588,23.3,23.3,0,0,0,1.13-2.719,29.6,29.6,0,0,1,2.4-5.8,9.266,9.266,0,0,1,4.937-3.838,45.163,45.163,0,0,1,5.664-1.435,18.757,18.757,0,0,0,4.924-1.677,10.312,10.312,0,0,0,3.333-3,11.257,11.257,0,0,0,2.118-6.129,17.542,17.542,0,0,0-.161-2.418,7.987,7.987,0,0,1,.314,2.421,11.177,11.177,0,0,1-2.044,6.288,10.519,10.519,0,0,1-3.4,3.126,18.9,18.9,0,0,1-5,1.746,45.962,45.962,0,0,0-5.611,1.443,8.9,8.9,0,0,0-4.736,3.686,29.667,29.667,0,0,0-2.37,5.722,23.405,23.405,0,0,1-1.159,2.763,8.654,8.654,0,0,1-6.419,4.732c-1.609.406-3.123.667-4.446,1.1a7.332,7.332,0,0,0-4.733,4.2,3.7,3.7,0,0,0-.144,1.753C558.948,260.09,559.015,260.3,559,260.3Z",
    transform: "translate(-558.703 -220.711)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.488 80.441)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M603.911,327.019a2.155,2.155,0,0,1,.052.474,5.046,5.046,0,0,1-.139,1.367,7.768,7.768,0,0,1-2.86,4.088,12.752,12.752,0,0,1-3,1.782,39.687,39.687,0,0,1-3.768,1.3,31.124,31.124,0,0,0-4.092,1.494,11.819,11.819,0,0,0-3.724,2.716c-1.1,1.156-2.057,2.419-3.114,3.534a14.249,14.249,0,0,1-3.487,2.729,15.323,15.323,0,0,1-7.2,1.871,14.268,14.268,0,0,1-4.953-.823,9.07,9.07,0,0,1-1.257-.539,2.17,2.17,0,0,1-.416-.231,2.191,2.191,0,0,1,.45.159,12.156,12.156,0,0,0,1.273.465,14.936,14.936,0,0,0,4.9.689,15.283,15.283,0,0,0,7.024-1.909,14.023,14.023,0,0,0,3.383-2.677c1.035-1.1,1.983-2.362,3.109-3.542a12.136,12.136,0,0,1,3.844-2.793,30.628,30.628,0,0,1,4.151-1.492c1.338-.407,2.609-.785,3.747-1.257a12.7,12.7,0,0,0,2.955-1.7,7.808,7.808,0,0,0,2.884-3.908A8.946,8.946,0,0,0,603.911,327.019Z",
    transform: "translate(-565.957 -327.019)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.028 57.616)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M600.765,182.261l-6.3.149a10.31,10.31,0,0,1-1.426,3.576,108.826,108.826,0,0,1-10.372-26.335c.148-.493.322-1.037.541-1.645a6.985,6.985,0,0,0-.083-2.771c-.176-1.1-.484-2.573-.576-3.256-.281-2.082-.616-2.409-1.342-2.173-.988.32.406,5.847-.4,5.966-.435.064-.967-1.829-1.121-3.382s-.857-6.332-1.37-6.65c-.753-.467-1.409.272-1.218,1.818.192,1.566.435,6.235-.386,6.3s-1.488-7.86-1.488-7.86.128-1.724-.823-1.683c-1.715.075-.375,8.427-.228,9.218.1.551-.788.651-.866.054-.081-.615-.495-7.923-2.24-7.864-1.34.045,1.037,6.883.285,8.468s-1.275-5.383-2.554-5.287c-.476.036-.828.129.047,4.072a88.97,88.97,0,0,0,3.058,9.243c2.027,10.933,10.924,45.912,24.873,39.509,7.8-3.583,10.971-19.462,10.971-19.462Z",
    transform: "translate(-568.301 -144.249)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.251)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M575.556,154.047a.429.429,0,0,0,.182-.025.4.4,0,0,0,.285-.437c-.018-.47-.092-1.154-.2-2.038a29.414,29.414,0,0,1-.348-3.224c-.01-.633.006-1.314.042-2.036a7.1,7.1,0,0,1,.11-1.09c.059-.343.288-.735.553-.688l.03.005h.013c.269-.012.48.2.566.518a2.979,2.979,0,0,1,.1,1.012v.024a61.308,61.308,0,0,0,.809,6.318c.061.282.124.567.212.854a4.109,4.109,0,0,0,.157.434,1.351,1.351,0,0,0,.129.225.412.412,0,0,0,.316.2.566.566,0,0,0,.476-.4,2.283,2.283,0,0,0,.141-.465,6.994,6.994,0,0,0,.122-.923,27.6,27.6,0,0,0-.051-3.785,8.75,8.75,0,0,1-.079-1.9,1.051,1.051,0,0,1,.372-.706.409.409,0,0,1,.325-.042.772.772,0,0,1,.18.078.247.247,0,0,1,.083.112,9.453,9.453,0,0,1,.525,1.9c.134.67.25,1.352.357,2.042s.2,1.388.287,2.092a14.508,14.508,0,0,0,.349,2.152,7.146,7.146,0,0,0,.341,1.069,1.911,1.911,0,0,0,.312.535.449.449,0,0,0,.453.165.484.484,0,0,0,.309-.34,3.718,3.718,0,0,0,.079-1.177c-.016-.375-.047-.746-.079-1.118-.054-.637-.115-1.267-.136-1.889a6.338,6.338,0,0,1,.023-.91,1.45,1.45,0,0,1,.092-.395.355.355,0,0,1,.073-.113c.012-.012.02-.007.029-.019l.1-.028c.5-.207.669.491.8,1.054.117.586.19,1.193.308,1.79.2,1.192.454,2.376.587,3.515a4.065,4.065,0,0,1-.067,1.628l-.531,1.623-.016.048.011.051a87.528,87.528,0,0,0,3.385,10.941c1.2,3.229,2.4,6.019,3.453,8.3s2,4.044,2.653,5.244l.787,1.353a3.233,3.233,0,0,0,.292.455,3.151,3.151,0,0,0-.232-.488c-.18-.342-.422-.8-.729-1.382-.614-1.218-1.523-2.992-2.542-5.285s-2.188-5.086-3.359-8.315a89.947,89.947,0,0,1-3.31-10.9l0,.1.53-1.6a4.4,4.4,0,0,0,.093-1.811c-.135-1.183-.383-2.333-.58-3.531-.117-.592-.188-1.2-.31-1.82a3.6,3.6,0,0,0-.309-.937.914.914,0,0,0-.418-.421.933.933,0,0,0-.6-.024l-.127.036a.648.648,0,0,0-.172.1.732.732,0,0,0-.191.269,1.859,1.859,0,0,0-.126.517,6.729,6.729,0,0,0-.026.976c.022.642.083,1.277.138,1.912.031.369.062.736.078,1.1a3.564,3.564,0,0,1-.056,1.017c-.019.079-.057.064-.014.1l0,0c0-.025.006.039,0,.028v-.008a.047.047,0,0,1,0-.026c0-.007.02-.033.011-.036a.113.113,0,0,1-.045-.042,1.624,1.624,0,0,1-.232-.41,6.966,6.966,0,0,1-.321-1,14.28,14.28,0,0,1-.341-2.1c-.085-.712-.184-1.413-.293-2.108s-.227-1.381-.365-2.06a9.389,9.389,0,0,0-.575-2.021.68.68,0,0,0-.237-.266,1.174,1.174,0,0,0-.282-.119.824.824,0,0,0-.639.089,1.416,1.416,0,0,0-.559.985,3.585,3.585,0,0,0-.013,1.037c.038.323.069.64.095.959a27.456,27.456,0,0,1,.068,3.727,6.737,6.737,0,0,1-.11.874,1.952,1.952,0,0,1-.115.392.488.488,0,0,1-.083.141c-.027.063-.051-.014-.049.088.039-.077,0-.034-.028-.1a1.071,1.071,0,0,1-.09-.157,3.791,3.791,0,0,1-.143-.387c-.084-.269-.148-.547-.21-.823a62.865,62.865,0,0,1-.855-6.269v.024a3.243,3.243,0,0,0-.123-1.125,1.146,1.146,0,0,0-.3-.5.786.786,0,0,0-.561-.2l.042,0a.653.653,0,0,0-.652.313,1.623,1.623,0,0,0-.232.588,7.039,7.039,0,0,0-.1,1.137c-.027.728-.033,1.413-.012,2.053a26.986,26.986,0,0,0,.418,3.239c.132.879.23,1.562.272,2.022a.357.357,0,0,1-.221.4C575.616,154.031,575.554,154.038,575.556,154.047Z",
    transform: "translate(-575.241 -144.228)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M505.607,208.23a16.254,16.254,0,0,0-4.383.5c-3.907,1.028-10.653,5.116-10.932,10.167h4.9s-2.744,5.841-1.937,5.3a63.044,63.044,0,0,0,6.256-5.635Z",
    transform: "translate(-490.291 -102.183)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.532)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M598.338,86.214c-.108.009-.553-4.041-.994-9.048s-.709-9.073-.6-9.082.552,4.041.993,9.048S598.446,86.2,598.338,86.214Z",
    transform: "translate(-596.72 -68.084)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.003 0.247)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M622.406,68.411c.089.063-3.221,4.868-7.393,10.73s-7.626,10.565-7.715,10.5,3.221-4.866,7.394-10.73S622.318,68.348,622.406,68.411Z",
    transform: "translate(-607.297 -68.41)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.708 22.012)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M633.493,97.186c.022.106-3.841.99-8.628,1.974s-8.686,1.695-8.708,1.588,3.841-.99,8.628-1.974S633.471,97.079,633.493,97.186Z",
    transform: "translate(-616.158 -97.175)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(683.18 253.987)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.129 13.902)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "matrix(1, 0, 0, 1, -265.31, -22.39)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M508.321,97.147a1.412,1.412,0,0,1-.855-1.238l-.3-7.025a1.412,1.412,0,0,1,1.735-1.435,4.388,4.388,0,0,0,3.416-.675,3.952,3.952,0,0,0,1.766-2.587,4.045,4.045,0,0,0-.849-3.039,4.506,4.506,0,0,0-2.982-1.795,5.29,5.29,0,0,0-5.371,3.811,1.412,1.412,0,1,1-2.725-.74,8.134,8.134,0,0,1,8.42-5.877,7.284,7.284,0,0,1,4.911,2.9,6.873,6.873,0,0,1,1.384,5.2,6.78,6.78,0,0,1-2.986,4.481,7.394,7.394,0,0,1-3.83,1.25l.235,5.415a1.413,1.413,0,0,1-1.967,1.359Z",
    transform: "translate(-236.79 -54.11)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.98 22.436)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "v",
    transform: "matrix(1, 0, 0, 1, -271.29, -44.83)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M512.313,107.231a1.155,1.155,0,1,1-1.231-1.073A1.155,1.155,0,0,1,512.313,107.231Z",
    transform: "translate(-238.72 -61.33)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M478.176,82.771a2.907,2.907,0,0,0,.069-.461c.036-.329.085-.777.148-1.353a15.928,15.928,0,0,1,.365-2.175c.1-.424.151-.9.306-1.372s.3-.989.47-1.528a26.015,26.015,0,0,1,3.763-7.209A25.374,25.374,0,0,1,506.754,58.8c.58.055,1.152.21,1.735.312a11.9,11.9,0,0,1,1.741.42A24.037,24.037,0,0,1,517,62.6a25.312,25.312,0,0,1,10,12.56,24.71,24.71,0,0,1,1.484,8.632,24.266,24.266,0,0,1-1.583,8.885l-.341.864-.045.114.046.107c1.9,4.371,3.759,8.658,5.563,12.813l.318-.362-11.332-4.354-.14-.054-.11.106a25.336,25.336,0,0,1-10.7,6.178,25.167,25.167,0,0,1-20.43-3.171,25.926,25.926,0,0,1-6.38-5.941,25.094,25.094,0,0,1-4.84-11.6q-.135-1.108-.238-1.968-.022-.849-.038-1.446c-.012-.372-.022-.664-.029-.886a1.544,1.544,0,0,0-.025-.3,1.683,1.683,0,0,0-.018.3c0,.222-.007.515-.011.888q0,.6,0,1.454.087.867.2,1.985a24.964,24.964,0,0,0,4.763,11.775,26.12,26.12,0,0,0,6.426,6.068,25.483,25.483,0,0,0,20.74,3.311,25.751,25.751,0,0,0,10.917-6.266l-.25.052,11.326,4.372.57.22-.252-.582-5.555-12.816v.221l.35-.883a24.78,24.78,0,0,0,1.616-9.083,25.235,25.235,0,0,0-1.525-8.821,25.767,25.767,0,0,0-10.223-12.794,24.457,24.457,0,0,0-6.9-3.1,12.3,12.3,0,0,0-1.772-.421c-.594-.1-1.176-.257-1.765-.311a24.927,24.927,0,0,0-15.737,3.077,25.456,25.456,0,0,0-8,7.074,25.9,25.9,0,0,0-3.726,7.325q-.238.819-.45,1.548c-.149.482-.194.959-.286,1.387a14.979,14.979,0,0,0-.319,2.2c-.042.579-.074,1.031-.1,1.362A3.238,3.238,0,0,0,478.176,82.771Z",
    transform: "translate(-478.144 -58.132)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidTax);
export default __webpack_public_path__ + "static/media/InvalidTax.ef765ffd886f4f78dc2e01266bc1e37f.svg";
export { ForwardRef as ReactComponent };